export interface MessageAttachment {
    id: number;
    originalFilename: string;
    mimeType: string;
    fileSize: number;
}

export const MESSAGE_ATTACHMENT_ACCEPT = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".txt",
    ".csv",
    ".png",
    ".jpg",
    ".jpeg",
    ".gif",
    ".webp",
    ".zip",
    ".rar",
    ".7z",
].join(",");

export const MESSAGE_ATTACHMENT_MAX_FILES = 5;

export const MESSAGE_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;

export function formatMessageFileSize(bytes: number) {
    if (!Number.isFinite(bytes) || bytes <= 0) {
        return "0 B";
    }

    if (bytes < 1024) {
        return `${bytes} B`;
    }

    if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function isMessageImageAttachment(mimeType: string) {
    return mimeType.startsWith("image/");
}
